import * as yup from "yup";
import { emailValidation, usernameValidator } from "./commonValidators";

const editUserValidatorCommonFields = yup.object({
  first_name: usernameValidator("First name"),
  last_name: usernameValidator("Last name"),
  email: emailValidation,
  password: yup.string(),
  confirm_password: yup
    .string()
    .test(
      "confirmPassword",
      "Passwords must match",
      (value, context) => value === context.parent.password,
    ),
});

export default function editUserValidator(isSuperuser) {
  if (!isSuperuser)
    return editUserValidatorCommonFields.concat(
      yup.object({
        groupname: yup.string().required("Role name is required"),
      }),
    );
  return editUserValidatorCommonFields;
}
